import { useWidget } from "../../../providers/widget"
import { AmenitiesWidgetConfig } from "../config"
import Stylesheet from "../../../components/Stylesheet"
import AmenitiesContent from "./AmenitiesContent"
import WebFont from "../../../components/WebFont"
import WidgetSection from "../../../components/WidgetSection"
import { useAmenitiesCss } from "../hooks/useAmenitiesCss"
import { useFetchAmenities } from "../data"
import { resolveWidgetSpacingStyle } from "@homerunner-next/widget-core/spacing"

export function AmenitiesWidgetContent() {
  const { options, resolvedTheme } = useWidget<AmenitiesWidgetConfig>()
  const cssString = useAmenitiesCss()

  // The section title only renders once we know there's actual content to show.
  // React Query dedupes this with the call inside <AmenitiesContent />.
  const { data } = useFetchAmenities(options.filter)
  const hasContent = (data?.result?.amenities?.length ?? 0) > 0

  return (
    <div
      // Legacy `aminities` class names ride along so customCss saved on
      // pre-rename widget records keeps applying (same for the grid/item/icon/
      // name/dialog classes below and in AmenitiesList/AmenitiesSkeleton).
      className={`homerunner-amenities-container homerunner-amenities-app homerunner-aminities-container homerunner-aminities-app w-full ${resolvedTheme === 'dark' ? 'dark' : ''}`}
      style={resolveWidgetSpacingStyle(options)}
      suppressHydrationWarning
    >
      <WebFont icoFont={true} />
      <Stylesheet css={cssString} />
      {hasContent && (
        <WidgetSection show={options.section?.show} title={options.section?.title} forceHeadingInMarkup />
      )}
      <AmenitiesContent />
    </div>
  )
}
